import { FC } from 'react';
import { ISeriesBooksPageData } from '@/interfaces/seriesBooksPage.interface';
import { ABSOLUTE_URL } from '@/helpers/variables';
import { removeAllBrackertsFromString } from '@/helpers/helpers';

interface IBookRatingJsonMarkup {
  book: ISeriesBooksPageData;
  authorName?: string;
}

const SeriesJsonMarkup: FC<IBookRatingJsonMarkup> = ({ book, authorName }) => {
  const books = book.books_list.map((item) => ({
    '@type': item.type === 'audio_book' ? 'Audiobook' : 'Book',
    name: item.book.title,
    url: `${ABSOLUTE_URL}/lib/id${item.id}`,
    image: `${ABSOLUTE_URL}/covers_200/${item.external_id}.jpg`,
    bookFormat: item.type === 'audio_book' ? 'https://schema.org/AudiobookFormat' : 'https://schema.org/EBook',
  }));

  const author = authorName!?.length > 0 ? { author: { '@type': 'Person', name: authorName } } : {};

  const getDescription = () => {
    const getBookWithDescription = book.books_list.find((item) => {
      return item.book.description.length > 1;
    });
    return getBookWithDescription?.book.description || '';
  };

  const serieDescription = getDescription();

  const seriesData = {
    '@context': 'https://schema.org',
    '@type': 'Series',
    name: book.title,
    description: removeAllBrackertsFromString(serieDescription),
    url: `${ABSOLUTE_URL}/series/${book.title_translit}`,
    ...author,
    publisher: {
      '@type': 'Organization',
      name: 'Fantasy Worlds',
    },
    hasPart: books,
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(seriesData, null, 2) }} key="product-jsonld" />;
};

export default SeriesJsonMarkup;
